jQuery(document).ready(function($) {

  // ---------------------------------------------------------- AUTO LOGIN UTENTE - CAMPAGNE
  // ----------------------------------------------------------
  // se l'utente non è loggato e c'è il token allora si sta registrando
  if ( (typeof RwAjaxRiservata != 'undefined') && (typeof RwClassRiservata != 'undefined') ) {
    if(RwUtil.getUrlParam('pcma_key')){
      window.name = 'attivaGestore';
      RwAjaxRiservata.RegistraGestore();
    }

    // mostra modale di login
    if(RwUtil.getUrlParam('show')){

      // mostro modale accedi se ?show=login
      if(RwUtil.getUrlParam('show') == 'login'){
        // RwAjaxRiservata.LogReg('area-riservata-login-register');
        $('#main-logreg').click();
      }

    }
  }


  // ---------------------------------------------------------- MODALE ACCEDI /REGISTRATI
  // ----------------------------------------------------------
  // gestione azioni riservata al click
  if (typeof RwAjaxRiservata != 'undefined') {

    // login
    $('#pc-accesso-riservata a, #pc-accesso-commenti a, #main-logreg i, .ubp-logreg ').click(function(e){
      e.preventDefault();
      RwAjaxRiservata.LogReg('area-riservata-login-register');
    });
    //
    // $('#pc-accesso-riservata a, #pc-accesso-commenti a, #main-logreg i, .ubp-logreg, .area-riservata.menu-item a ').click(function(e){
    //   e.preventDefault();
    //
    //   if(this.parentNode.classList.contains('area-riservata') || !document.getElementById('networkMenuToggler').classList.contains('collapsed')){
    //     document.getElementById('networkMenuToggler').click();
    //   }
    //
    //   RwAjaxRiservata.LogReg('area-riservata-login-register');
    // });

    // logout
    $('#pc-logout, .ubp-pc-logout').click(function(e){
      e.preventDefault();
      RwAjaxRiservata.LogReg('area-riservata-logout');
    });

  }


  // ---------------------------------------------------------- COMMENTI
  // ----------------------------------------------------------
  // pre-fill del campo nome ed email
  if (typeof RwAjaxRiservata != 'undefined') {
    var nomeCognome = $('meta[name="user"]').attr('nome') + ' ' + $('meta[name="user"]').attr('cognome');
    var email = $('meta[name="user"]').attr('email');

    $('#comments #respond input#author').val(nomeCognome);
    $('#comments #respond input#email').val(email);
  }



  // ---------------------------------------------------------- LOVE - SOLO DA HOME PAGE
  // ----------------------------------------------------------

  // parte la funzione che consente di mettere i like sulle tiles in GRIGLIA LISTA e MAPPA
  // attiva su tutte le pagine — il backend fa già check rwpc_allowed() lato AJAX
  if (typeof RwAjaxLove != 'undefined') {
    RwAjaxLove.start();
  }

  // filtro isotope per visualizzare le gallery preferite
  // il pulsante è dentro il menu item .area-riservata (desktop + mobile)
  $('#start-love, .ubp-start-love').click(function(e){
    e.preventDefault();

    // toggle SINCRONIZZATO tra tutti i trigger presenti (desktop + mobile)
    var $triggers = $('#start-love, .ubp-start-love');
    var willActivate = !$(this).hasClass('love-active');

    $triggers.toggleClass('love-active', willActivate);
    $triggers.find('i').toggleClass('fas', willActivate).toggleClass('fal', !willActivate);

    if (willActivate) {
      $('#iso').isotope({ filter: '.loved' });
      $('.iso-list').isotope({ filter: '.loved' });
    } else {
      $('#iso').isotope({ filter: '*' });
      $('.iso-list').isotope({ filter: '*' });
    }
  });



  // ---------------------------------------------------------- VOTE - SOLO DA CONCORSI
  // ----------------------------------------------------------

  // parte la funzione che consente di mettere i like sulle tiles in GRIGLIA LISTA e MAPPA
  if (typeof RwAjaxVote != 'undefined' && $('body').hasClass('single-concorsi')) {
    RwAjaxVote.start();
  }

  // filtro isotope per visualizzare le gallery preferite
  // il pulsante si trova nel menu .menu-riservata
  $('#start-vote').click(function(e){
    e.preventDefault();

    // l'icona del cuore sul menu
    var icona = $('i', this);

    // toggle class vote-active per evincere da altre funzioni se è attiva e filtro di conseguenza
    if($(this).hasClass('vote-active')){
      // se era attivo il vote rimuovi la classe e spegnilo
      $(this).removeClass('vote-active');
      icona.removeClass('fas').addClass('fal');
      // RwIso.layout('', 'vote-off');
      $('#iso').isotope({ filter: '*' });
      $('.iso-list').isotope({ filter: '*' });
    } else {
      // se non era attivo il vote aggiungi la classe e accendilo
      $(this).addClass('vote-active');
      icona.removeClass('fal').addClass('fas');
      // RwIso.layout('', 'vote-on');
      $('#iso').isotope({ filter: '.voted' });
      $('.iso-list').isotope({ filter: '.voted' });
    }
  });


  // ---------------------------------------------------------- STREAMING
  // ----------------------------------------------------------

  $('#login-streaming').click(function(){
    $('#main-logreg i').click();
  });

});
